import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const statusData = [
    { name: "Approved", value: 400 },
    { name: "On Hold", value: 300 },
    { name: "Completed", value: 200 },
    { name: "Rejected", value: 100 },
    { name: "Dispatched", value: 150 },
];

const STATUS_COLORS = ["#28a745", "#ffc107", "#0d6efd", "#dc3545", "#35b2dcff"];

const PieChartComponent = () => {
    return (
        <div className="card shadow-sm border-0">
            <div className="card-body">
                <h5 className="card-title">Order Status Distribution</h5>
                <p className="text-muted mb-4">
                    Current status breakdown of all orders
                </p>
                <PieChart width={350} height={300}>
                    <Pie
                        data={statusData}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={4}
                        dataKey="value"
                    >
                        {statusData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={
                                    STATUS_COLORS[index % STATUS_COLORS.length]
                                }
                            />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </div>
        </div>
    );
};

export default PieChartComponent;
